import { useQuery } from '@apollo/client';

import { InfiniteScroll } from '../../components/infinitescroll';
import {
  getNodes,
  loadMoreFromConnection,
  PAGINATION_PAGE_SIZE,
  TransportAnalyzerResultsQuery,
  TransportAnalyzerResultsQueryVariables,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { TransportAnalyzerResultsList } from '../components/transport_analyzer_results_list';
import { transportAnalyzerResultsQuery } from '../graphql';

export type TransportAnalyzerResultNode = NonNullable<
  NonNullable<NonNullable<TransportAnalyzerResultsQuery['transportAnalyzerResults']['edges']>[number]>['node']
>;

class TransportAnalyzerResultsLoadingContainer extends Loader<
  TransportAnalyzerResultsQuery,
  { results: TransportAnalyzerResultNode[] },
  TransportAnalyzerResultsQueryVariables
> {}

export const TransportAnalyzerContainer = () => {
  const result = useQuery<TransportAnalyzerResultsQuery, TransportAnalyzerResultsQueryVariables>(
    transportAnalyzerResultsQuery,
    {
      variables: {
        first: PAGINATION_PAGE_SIZE,
      },
    },
  );

  return (
    <TransportAnalyzerResultsLoadingContainer
      result={result}
      mapData={({ data }) => ({
        results: getNodes(data.transportAnalyzerResults),
      })}>
      {({ results }) => (
        <InfiniteScroll
          loadMoreEntries={() =>
            loadMoreFromConnection(transportAnalyzerResultsQuery, result, ['transportAnalyzerResults'])
          }>
          <TransportAnalyzerResultsList results={results} />
        </InfiniteScroll>
      )}
    </TransportAnalyzerResultsLoadingContainer>
  );
};
